export type Department = {
  id: number;
  name: string;
};

export type Job = {
  id: number;
  internal_job_id: number;
  title: string;
  updated_at: string;
  requisition_id: string;
  location: {
    name: string;
  };
  departments: Partial<Department>[];
  absolute_url: string;
  metadata: object | null;
};

export type JobList = {
  jobs: Partial<Job>[];
  meta: { total: number };
};

export const fetchJobs = async (BOARD_TOKEN: string): Promise<JobList> => {
  try {
    const data = await fetch(
      `https://boards-api.greenhouse.io/v1/boards/${BOARD_TOKEN}/jobs?content=true`
    );
    const jobsList = await data.json();
    return jobsList;
  } catch (e) {
    console.error(e);
  }
};

export const partitionJobs = (jobs: Partial<Job>[]) => {
  const categorizedJobs = jobs.reduce((jobsMap, job) => {
    const { departments } = job;
    departments.forEach((department) => {
      jobsMap[department.name] = [...(jobsMap[department.name] || []), job];
    });
    return jobsMap;
  }, {});

  return categorizedJobs;
};
